<div class="spinner-overlay">
  <mat-spinner [diameter]="100" class="mt-3"></mat-spinner>
</div>
